import { getConfig } from "@engaging-tech/ssr-config"

import { GET_WHW_AWARDS } from "../../graphql/queries/awards"
import { apollo } from "../../lib/Apollo"

const GRAPHQL_API_URL = () => `${getConfig().api.url}${getConfig().api.endpoints.graphql}`

export default async function getWhwAwards() {
  return apollo.query({
    uri: GRAPHQL_API_URL,
    query: GET_WHW_AWARDS
  })
}
